import React from "react";
import "./Footer.css";
import { FaInstagram, FaLinkedin, FaEnvelope } from "react-icons/fa"; // Example icons

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="social-links">
        <a
          href="https://instagram.com/tjwit.media"
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon"
        >
          <FaInstagram />
        </a>
        <a href="mailto:tylerwit@gmail.com" className="social-icon">
          <FaEnvelope />
        </a>
        {/* Add other links like LinkedIn if you have one */}
        <a
          href="https://linkedin.com/in/tjwit"
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon"
        >
          <FaLinkedin />
        </a>
      </div>
      <p className="copyright-text">
        &copy; {currentYear} TjWit Media. All Rights Reserved.
      </p>
    </footer>
  );
}

export default Footer;
